module.exports = __webpack_public_path__ + "img/bg43.e270ee03.png";